export default "__VITE_ASSET__RZUa0gAW__"